import React from 'react';

export default function Meter(props){
    return(
        <meter value={props.value}></meter>
    )
}